import { useRouter } from 'next/router';
import FormCommon from './FormCommon';

export default function QuoteForm({ source_page, callback }: any) {
    const { pathname, query, locale } = useRouter();
    let textareaPlaceholder = `Your Message (To assist you efficiently, please describe your specific concerns in this message box. Include details like the appliances you need to back up, typical scenarios requiring backup power, and any special considerations for your home's electrical circuits. The more precise your information, the better we can address your needs.)(Optional)`;
    if (pathname === '/delta-pro-ultra-daily-use') {
        textareaPlaceholder = `Your Message (To assist you efficiently, please describe your specific concerns in this message box. Please include details like your monthly electricity bills, monthly power consumption(in kwh), and your Time of Use rate.The more precise your information, the better we can address your needs.)(Optional)`;
    }
    const IS_COSTCO = query?.source === 'costco' && locale === 'us';
    const THEME_WHITE = ['/ef-quote-form', '/delta-pro-3-portable-power-station', '/calculators/delta-pro-ultra', '/power-preparedness'];
    const theme = THEME_WHITE.includes(pathname) ? 'white' : 'black';
    let data = {
        theme,
        isPrivacy: true,
        isSubscribe: true,
        isRecaptcha: true,
        list: [
            // {
            //     itemKey: 'firstName',
            //     itemVal: '',
            //     formType: 'input',
            //     isRequire: false,
            //     formWidth: '50',
            //     placeholder: 'First Name(Optional)',
            //     emptyTips: 'First Name cannot be empty.',
            // },
            // {
            //     itemKey: 'lastName',
            //     itemVal: '',
            //     formType: 'input',
            //     isRequire: false,
            //     formWidth: '50',
            //     placeholder: 'Last Name(Optional)',
            //     emptyTips: 'Last Name cannot be empty.',
            // },
            {
                itemKey: 'fullName',
                itemVal: '',
                isRequire: true,
                formType: 'input',
                formWidth: '50',
                placeholder: 'Full Name*',
                emptyTips: 'Full Name cannot be empty.',
                maxLen: '10',
            },
            {
                itemKey: 'zipCode',
                itemVal: '',
                formType: 'input',
                isRequire: true,
                formWidth: '50',
                emptyTips: 'ZIP Code cannot be empty',
                placeholder: 'ZIP Code (Optional)*',
            },
            {
                itemKey: 'state',
                itemVal: '',
                formType: 'select',
                isRequire: true,
                theme,
                isSelectInterface: !IS_COSTCO,
                selectList: IS_COSTCO
                    ? [
                          {
                              label: 'California',
                              value: 'California',
                          },
                          {
                              label: 'Texas',
                              value: 'Texas',
                          },
                          {
                              label: 'Florida',
                              value: 'Florida',
                          },
                          {
                              label: 'Georgia',
                              value: 'Georgia',
                          },
                          {
                              label: 'More regions will be coming soon',
                              value: 'More regions will be coming soon',
                          },
                      ]
                    : undefined,
                formWidth: '50',
                placeholder: 'State*',
                emptyTips: 'Please select a state.',
            },
            {
                itemKey: 'phone',
                itemVal: '',
                formType: 'input',
                isRequire: true,
                formWidth: '50',
                placeholder: 'Phone Number*',
                emptyTips: 'Phone Number is invalid or cannot be empty.',
            },
            {
                itemKey: 'email',
                itemVal: '',
                formType: 'email',
                isRequire: true,
                formWidth: '50',
                placeholder: 'Email*',
                emptyTips: 'Email cannot be empty.',
            },
            {
                itemKey: 'bestTime',
                itemVal: '',
                formType: 'date',
                isRequire: true,
                formWidth: '50',
                emptyTips: 'Preferred Contact Date cannot be empty.',
                placeholder: 'Preferred Contact Date*',
            },
            {
                itemKey: 'bestTimeRange',
                itemVal: '',
                formType: 'select',
                isRequire: true,
                theme,
                isSelectInterface: false,
                selectList: [
                    {
                        label: 'Morning',
                        value: 'Morning',
                    },
                    {
                        label: 'Noon',
                        value: 'Noon',
                    },
                    {
                        label: 'Night',
                        value: 'Night',
                    },
                ],
                formWidth: '50',
                emptyTips: 'Preferred Contact Time cannot be empty.',
                placeholder: 'Preferred Contact Time*',
            },
            {
                itemKey: 'products',
                itemVal: '',
                formType: 'select',
                isRequire: true,
                theme,
                isSelectInterface: false,
                selectList: [
                    {
                        label: 'DELTA Pro Ultra X',
                        value: 'DELTA Pro Ultra X',
                    },
                    {
                        label: 'DELTA Pro Ultra',
                        value: 'DELTA Pro Ultra',
                    },
                    {
                        label: 'DELTA Pro 3',
                        value: 'DELTA Pro 3',
                    },
                ],
                formWidth: '50',
                emptyTips: 'Interested Products cannot be empty.',
                placeholder: 'Interested Products*',
            },
            // {
            //     itemKey: 'bestTime',
            //     itemVal: '',
            //     formType: 'input',
            //     isRequire: false,
            //     formWidth: '50',
            //     placeholder: 'Best Time to Contact',
            // },
            // {
            //     itemKey: 'products',
            //     itemVal: '',
            //     formType: 'select',
            //     isRequire: false,
            //     isSelectInterface: false,
            //     formWidth: '50',
            //     placeholder: 'Interested Products',
            //     theme,
            //     selectList: IS_COSTCO
            //         ? [
            //               {
            //                   label: 'EcoFlow DELTA Pro Ultra 60 kWh (installation included)',
            //                   value: 'EcoFlow DELTA Pro Ultra 60 kWh (installation included)',
            //               },
            //               {
            //                   label: 'EcoFlow DELTA Pro Ultra 90 kWh (installation included)',
            //                   value: 'EcoFlow DELTA Pro Ultra 90 kWh (installation included)',
            //               },
            //           ]
            //         : [
            //               {
            //                   label: 'DELTA Pro Ultra',
            //                   value: 'DELTA Pro Ultra',
            //               },
            //               {
            //                   label: 'DELTA Pro 3',
            //                   value: 'DELTA Pro 3',
            //               },
            //               {
            //                   label: 'DELTA Pro',
            //                   value: 'DELTA Pro',
            //               },
            //               {
            //                   label: 'Smart Home Panel 2',
            //                   value: 'Smart Home Panel 2',
            //               },
            //           ],
            // },
            // {
            //     itemKey: 'address',
            //     itemVal: '',
            //     formType: 'input',
            //     isRequire: false,
            //     formWidth: '50',
            //     placeholder: 'Address(Optional)',
            // },
            // {
            //     itemKey: 'city',
            //     itemVal: '',
            //     formType: 'input',
            //     isRequire: false,
            //     formWidth: '50',
            //     placeholder: 'City(Optional)',
            //     emptyTips: 'City cannot be empty.',
            // },
            {
                formType: 'inputAndCheckbox',
                itemKey: 'answer6',
                itemVal: '',
                formWidth: '100',
                data: [
                    {
                        formType: 'input',
                        // number: true,
                        itemKey: 'answer6_number',
                        maxLen: '50',
                        itemVal: '',
                        isRequire: false,
                        formWidth: '50',
                        suffix: ' panel',
                        label: 'How many solar panels do you have (Fill in the amount, watts & open circuit voltage (if possible))?',
                    },
                    {
                        formType: 'checkbox',
                        itemKey: 'answer6_checkbox',
                        itemVal: [],
                        isRequire: false,
                        formWidth: '50',
                        selectList: [
                            {
                                label: 'rooftop solar panels',
                                value: 'rooftop solar panels',
                            },
                            {
                                label: 'portable solar panels',
                                value: 'portable solar panels',
                            },
                        ],
                    },
                ],
            },
            // {
            //     itemKey: 'answer1',
            //     itemVal: '',
            //     formType: 'radio',
            //     isRequire: false,
            //     formWidth: '100',
            //     placeholder: 'Would you need help to customize your solution ?',
            //     radioY: 'Yes',
            //     radioN: 'No',
            //     orderNum: '1',
            // },
            // {
            //     itemKey: 'answer2',
            //     itemVal: '',
            //     formType: 'radio',
            //     isRequire: false,
            //     formWidth: '100',
            //     placeholder: 'Are you interested in learning about financing options or available incentives?',
            //     radioY: 'Yes',
            //     radioN: 'No',
            //     orderNum: '2',
            // },
            // {
            //     itemKey: 'answer3',
            //     itemVal: '',
            //     formType: 'radio',
            //     isRequire: false,
            //     formWidth: '100',
            //     placeholder: "Do you have any existing energy systems (like solar panels) you'd like to integrate with?",
            //     radioY: 'Yes',
            //     radioN: 'No',
            //     orderNum: '3',
            // },
            // {
            //     itemKey: 'answer4',
            //     itemVal: '',
            //     formType: 'radio',
            //     isRequire: false,
            //     formWidth: '100',
            //     placeholder: 'Do you have concerns about the installation process?',
            //     radioY: 'Yes',
            //     radioN: 'No',
            //     orderNum: '4',
            // },
            {
                itemKey: 'answer7',
                itemVal: '',
                formType: 'textarea',
                isRequire: false,
                formWidth: '100',
                maxLen: 200,
                placeholder: 'Provide answers here:',
                // emptyTips: 'Message cannot be empty.',
                label: 'What are your essential household appliances?',
            },
        ],
    };

    // if (locale === 'us' && pathname === '/smart-home-panel-2' && query?.withHeader !== '1') {
    //     data.list = [
    //         ...data.list.slice(0, 8),
    //         {
    //             itemKey: 'answer5',
    //             itemVal: '',
    //             formType: 'select',
    //             isRequire: false,
    //             isSelectInterface: false,
    //             formWidth: '100',
    //             placeholder: 'Which energy solution are you interested in?',
    //             emptyTips: 'Please select an energy solution.',
    //             selectList: [
    //                 {
    //                     label: 'EcoFlow Smart Home Panel 2 + EcoFlow DELTA Pro Ultra',
    //                     value: 'EcoFlow Smart Home Panel 2 + EcoFlow DELTA Pro Ultra',
    //                 },
    //                 {
    //                     label: 'EcoFlow Smart Home Panel 2 + EcoFlow DELTA Pro 3',
    //                     value: 'EcoFlow Smart Home Panel 2 + EcoFlow DELTA Pro 3',
    //                 },
    //                 {
    //                     label: 'Others',
    //                     value: 'Others',
    //                 },
    //             ],
    //         },
    //         ...data.list.slice(8),
    //     ];
    // }
    // if (locale === 'ca' && (pathname === '/delta-pro-ultra' || pathname === '/calculators/delta-pro-ultra')) {
    //     data = {
    //         theme: 'black',
    //         isPrivacy: false,
    //         isSubscribe: false,
    //         isRecaptcha: true,
    //         list: [
    //             {
    //                 itemKey: 'firstName',
    //                 itemVal: '',
    //                 isRequire: true,
    //                 formType: 'input',
    //                 formWidth: '50',
    //                 placeholder: 'Full Name',
    //                 emptyTips: 'First name cannot be empty.',
    //                 maxLen: '10',
    //             },
    //             {
    //                 itemKey: 'email',
    //                 itemVal: '',
    //                 formType: 'email',
    //                 isRequire: true,
    //                 formWidth: '50',
    //                 placeholder: 'Email',
    //                 emptyTips: 'Email cannot be empty.',
    //             },
    //             {
    //                 itemKey: 'phone',
    //                 itemVal: '',
    //                 formType: 'input',
    //                 isRequire: true,
    //                 formWidth: '50',
    //                 placeholder: 'Phone Number',
    //                 emptyTips: 'Phone Number is invalid or cannot be empty.',
    //             },
    //             {
    //                 itemKey: 'bestTime',
    //                 itemVal: '',
    //                 formType: 'input',
    //                 isRequire: false,
    //                 formWidth: '50',
    //                 placeholder: 'Best Time to Contact',
    //             },
    //             {
    //                 itemKey: 'address',
    //                 itemVal: '',
    //                 formType: 'input',
    //                 isRequire: false,
    //                 formWidth: '50',
    //                 placeholder: 'Address',
    //             },
    //             {
    //                 itemKey: 'zipCode',
    //                 itemVal: '',
    //                 formType: 'input',
    //                 isRequire: false,
    //                 formWidth: '50',
    //                 placeholder: 'Postal Code',
    //             },
    //         ],
    //     };
    // }

    // if (locale === 'ca' && pathname === '/whole-home-backup-power-solution') {
    //     data.list = [
    //         {
    //             itemKey: 'FullName',
    //             itemVal: '',
    //             isRequire: true,
    //             formType: 'input',
    //             formWidth: '50',
    //             placeholder: 'Full Name*',
    //             emptyTips: 'FullName cannot be empty.',
    //             maxLen: '10',
    //         },
    //         {
    //             itemKey: 'email',
    //             itemVal: '',
    //             formType: 'email',
    //             isRequire: true,
    //             formWidth: '50',
    //             placeholder: 'Email*',
    //             emptyTips: 'Email cannot be empty.',
    //         },
    //         {
    //             itemKey: 'phone',
    //             itemVal: '',
    //             formType: 'input',
    //             isRequire: true,
    //             formWidth: '50',
    //             placeholder: 'Phone Number*',
    //             emptyTips: 'Phone Number is invalid or cannot be empty.',
    //         },
    //         {
    //             itemKey: 'bestTime',
    //             itemVal: '',
    //             formType: 'input',
    //             isRequire: false,
    //             formWidth: '50',
    //             placeholder: 'Best Time to Contact',
    //         },
    //         {
    //             itemKey: 'message',
    //             itemVal: '',
    //             formType: 'textarea',
    //             isRequire: false,
    //             formWidth: '50',
    //             placeholder: 'Message',
    //         },
    //     ];
    // }
    if (IS_COSTCO) {
        data.list.pop();
        data.list.pop();
    }

    return (
        <>
            <FormCommon id={`111`} source_page={source_page} data={data} callback={callback} />
        </>
    );
}
